import { Component, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { UserTimePipe } from "app/components/shared/UserTimePipe";
import { LoadingService } from "app/services/loading-service/loading.service";
import { ConfirmationService, SelectItem } from "primeng/api";
import { EntityListComponent } from 'app/components/entity-list/entity-list.component';
import { Rest } from 'app/rest/rest_client';
import { NotificationsService, Severity } from 'app/services/notifications-service/notifications.service';
import { AuthenticationService } from 'app/core/services/authentication/authentication.service';
import { I18nService } from 'app/services/i18n/i18n.service';
import { TranslateService } from '@ngx-translate/core';
import { ExcelService } from "app/services/excel-service/excel.service";
import { BreakdownService } from '../../../../services/table-management/breakdown.service';
import { BreakdownFormComponent } from '../breakdown-form/breakdown-form.component';

@Component({
  selector: 'app-breakdown-list',
  templateUrl: './breakdown-list.component.html',
  styleUrls: ['./breakdown-list.component.css'],
  providers:[BreakdownService],
  standalone: false,
})
export class BreakdownListComponent extends EntityListComponent<Rest.InvBreakdown> implements OnInit {

  @ViewChild(BreakdownFormComponent, { static: true })
    breakdownForm: BreakdownFormComponent;
  
    title: string = this.translateService.instant('tableManagement.breakdown.title');
    disableSave: boolean;
    EnabledFilter: SelectItem[];
    isCreateGranted: boolean;
    isDelegationUser: boolean;
    isDeleteGranted: boolean;

    @Input() vehicle: Rest.Vehicle;
  
    constructor(
      private breakdownService: BreakdownService,
      protected confirmationService: ConfirmationService,
      public notificationsService: NotificationsService,
      protected i18n: I18nService,
      authenticationService: AuthenticationService,
      protected loadingService: LoadingService,
      protected userTime: UserTimePipe,
      protected excelService: ExcelService,
      protected translateService: TranslateService,
    ) {
      super(
        breakdownService,
        confirmationService,
        notificationsService,
        i18n,
        authenticationService,
        loadingService,
        userTime,
        excelService
      );
      this.breakdownService = breakdownService;
    }
  
    ngOnInit() {
      super.ngOnInit();
      this.form = this.breakdownForm;
      this.setPermissions();
    }
    beforeLoad() {
      if (this.vehicle) this.paginationRequest.filters['vehicleId'] = [this.vehicle.id.toString()];   
      if(!this.paginationRequest.sortBy){
			this.paginationRequest.sortBy = "startDateWorkshop";
			this.paginationRequest.sortAsc= false;
		}
      
    }
  
    afterLoad() {
    }
    excelColumns = {};
    exportExcel() {
      this.setExcelColumns();
      let fileNameTitle = this.translateService.instant('tableManagement.breakdown.title');
      super.exportExcelWithColumns(fileNameTitle, this.excelColumns);
    }
    setExcelColumns() {

      const vehicle = (entity: any) => entity.vehicle.name ?? '';
      const driver = (entity: any) => `${entity.driver?.employee?.user?.surname1 ?? ''} ${entity.driver?.employee?.user?.surname2 ?? ''},  ${entity.driver?.employee.user?.name ?? ''}`;
      const startDateWorkshop = (entity: any) => entity.startDateWorkshop ?? '';
      const endDateWorkshop = (entity: any) => entity.endDateWorkshop ?? ''
      const breakdownReason = (entity: any) => entity.breakdownReason.reason ?? '';
      const closed = (entity: any) => entity.closed ?? '';

      this.excelColumns = {
        [this.translateService.instant('general.vehicle')]: { bindField: vehicle },
        [this.translateService.instant('tableManagement.sinister.driver')]: { bindField: driver },
        [this.translateService.instant('tableManagement.sinister.workshopStartDate')]: {bindField: startDateWorkshop},
        [this.translateService.instant('tableManagement.sinister.workshopEndDate')]: { bindField: endDateWorkshop },
        [this.translateService.instant('tableManagement.breakdown.breakdownReason.title')]: { bindField: breakdownReason },
        [this.translateService.instant('tableManagement.breakdown.closed')]: { bindField: closed },
      }
    }

    deleteBreakdown(breakdown){
      var that = this;
      this.breakdownService.deleteById(breakdown.id).then((response) =>{
        if (response) {
          that.notificationsService.add(Severity.success, '', this.translateService.instant('general.deleteSuccessfull'));
          that.refresh();
        } else {
          that.notificationsService.add(Severity.error, '', this.translateService.instant('general.deleteError'));
        }
      })

    }

    public onDeleteBreakdown(breakdown: Rest.InvBreakdown) {

      if (this.isDeleteGranted === false) {
        return;
      }

      this.confirmationService.confirm({
        accept: () => {
          this.deleteBreakdown(breakdown);
        },
        key: 'breakdown-list'
      });
    }

    setPermissions() {
        const user = this.authenticationService.user;
        this.isCreateGranted = this.authenticationService.isRoleGranted('INV_BREAKDOWN_CREATE', user);
        this.isDeleteGranted = this.authenticationService.isRoleGranted('INV_BREAKDOWN_DISABLE', user);
        this.isDelegationUser = !this.authenticationService.isRoleGranted('INV_DELEGATIONS_ADMIN', user);

    }

    openDialog(breakdown){
      if(!this.isDelegationUser){
        this.editDialog(breakdown);
      }
    }

}